import { z } from 'zod';
import {
    CardPointeReconciliationLookupOutcome,
    type CardPointeReconciliationLookupRequest,
    type CardPointeReconciliationLookupRequestDetails,
    type CardPointeReconciliationLookupResponseDetails,
    type CardPointeReconciliationLookupResult,
} from '../../../types/ipg/cardpointe/cardpointe-reconciliation.types';
import {
    CardPointeFundingRequestDetailsSchema,
    CardPointeFundingResponseDetailsSchema,
} from './cardpointe-funding.schemas';

export const CardPointeReconciliationLookupRequestSchema: z.ZodType<CardPointeReconciliationLookupRequest> =
    z.object({
        funding_date: z.string().regex(/^(?:\d{4}|\d{8})$/),
        gateway_txn_id: z.string().min(1),
        page: z.number().int().positive().optional(),
        limit: z.number().int().positive().optional(),
    });

export const CardPointeReconciliationLookupRequestDetailsSchema: z.ZodType<CardPointeReconciliationLookupRequestDetails> =
    z.object({
        fundingRequestDetails: CardPointeFundingRequestDetailsSchema,
        lookup: CardPointeReconciliationLookupRequestSchema,
    });

export const CardPointeReconciliationLookupResultSchema: z.ZodType<CardPointeReconciliationLookupResult> =
    z.object({
        gateway_txn_id: z.string().min(1),
        is_settled: z.boolean(),
        batched_amount: z.number().nonnegative().optional(),
        gateway_batch: z.string().min(1).optional(),
        settlement_status: z.string().min(1).optional(),
        funding_id: z.string().min(1).optional(),
        funding_transaction_id: z.string().min(1).optional(),
    });

export const CardPointeReconciliationLookupResponseDetailsSchema: z.ZodType<CardPointeReconciliationLookupResponseDetails> =
    z.discriminatedUnion('outcome', [
        z.object({
            outcome: z.literal(CardPointeReconciliationLookupOutcome.MATCHED),
            httpStatus: z.literal(200),
            fundingResponseDetails: CardPointeFundingResponseDetailsSchema,
            normalizedResult: CardPointeReconciliationLookupResultSchema,
        }),
        z.object({
            outcome: z.literal(CardPointeReconciliationLookupOutcome.UNMATCHED),
            httpStatus: z.number().int().positive(),
            fundingResponseDetails: CardPointeFundingResponseDetailsSchema,
            message: z.string().min(1),
        }),
        z.object({
            outcome: z.literal(CardPointeReconciliationLookupOutcome.MALFORMED_RESPONSE),
            httpStatus: z.number().int().positive(),
            fundingResponseDetails: CardPointeFundingResponseDetailsSchema,
            message: z.string().min(1),
        }),
    ]);
